enum LaboratoryContent {
    GENERAL = 'GENERAL',
    COLLECT = 'COLLECT',
    CHANGES = 'CHANGES',
    OBSERVATIONS = 'OBSERVATIONS',
}

export default LaboratoryContent;
